import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';
import { WebsocketService } from '../services/websocket.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private websocket: WebsocketService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    // @ts-ignore
  ): Observable<boolean> | boolean {
    if (this.auth.isAuthenticated()) {
      return true;
    } else {
      this.websocket.subscription$.unsubscribe();
      this.auth.logout();
      this.router.navigate(['/'], {
        queryParams: {
          loginAgain: true
        }
      });
    }
  }

}
